// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAOYnc8uD6FRA8_6bHYNf6sonkZQv7qC3M",
    authDomain: "cm-dunamis.firebaseapp.com",
    projectId: "cm-dunamis",
    storageBucket: "cm-dunamis.appspot.com",
    messagingSenderId: "956253924836",
    appId: "1:956253924836:web:7c58cd5f2dffb83a802bf1",
    measurementId: "G-FMF8VG21CT"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
